(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["em-product"]) return;
  try {
    
  if (!customElements.get('em-product-recommendations')) {
    customElements.define('em-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.loadToken = (this.loadToken || 0) + 1;
        this.load(this.loadToken);
      }
      disconnectedCallback() {
        this.loadToken = (this.loadToken || 0) + 1;
        if (this.requestController) this.requestController.abort();
      }
      async load(token) {
        for (const intent of ['complementary', 'related']) {
          if (!this.isConnected || token !== this.loadToken) return;
          const controller = new AbortController();
          this.requestController = controller;
          const timeout = setTimeout(() => controller.abort(), 8000);
          try {
            const url = new URL(this.dataset.url, window.location.origin);
            url.searchParams.set('intent', intent);
            const response = await fetch(url.toString(), { signal: controller.signal });
            if (!response.ok) continue;
            const document = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = document.querySelector('[data-em-recommendations-content]');
            if (!this.isConnected || token !== this.loadToken) return;
            if (content && content.querySelector('[data-em-recommendation]')) {
              this.innerHTML = content.innerHTML;
              this.hidden = false;
              this.dataset.loaded = 'true';
              return;
            }
          } catch (error) {
            if (!this.isConnected || token !== this.loadToken) return;
          } finally {
            clearTimeout(timeout);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
